'use client'

import React, { createContext, useContext } from 'react'

/**
 * True inside surfaces that should draw bitmaps live (laid out and animated
 * from block data) instead of the static thumbnail. Set by the bitmap
 * collection page; everywhere else (wallet, home feed, search) bitmaps stay
 * cheap static images.
 */
const BitmapLiveContext = createContext(false)

export const BitmapLiveProvider: React.FC<{ value: boolean; children: React.ReactNode }> = ({
	value,
	children
}) => <BitmapLiveContext.Provider value={value}>{children}</BitmapLiveContext.Provider>

export function useBitmapLive(): boolean {
	return useContext(BitmapLiveContext)
}
